import { render, staticRenderFns } from "./ConstructionDocumentationNewConstruction.vue?vue&type=template&id=050bd386&scoped=true&lang=pug&"
import script from "./ConstructionDocumentationNewConstruction.vue?vue&type=script&lang=ts&"
export * from "./ConstructionDocumentationNewConstruction.vue?vue&type=script&lang=ts&"
import style0 from "./ConstructionDocumentationNewConstruction.vue?vue&type=style&index=0&id=050bd386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050bd386",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
